<template>
  <div>
    <input
      type="hidden"
      :name="nom"
      v-model="stringifySelection"
    >
    <vue-select
      multiple
      :options="builtOptions"
      label="libelle"
      v-model="selection"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import vueSelect from 'vue-select'

export default {
  components: {
    'vue-select': vueSelect
  },
  props: {
    nom: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      default: function () { return [] }
    },
    cle: {
      type: String,
      default: ''
    },
    valeur: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selection: [],
      stringifySelection: ''
    }
  },
  computed: {
    builtOptions() {
      if (this.cle==='' && this.valeur==='') {
        return this.options
      } else {
        let outputOptions = []

        for (let [inputKey, inputValue] of Object.entries(this.options)) {
          let outputEntry = {}

          if (this.cle!=='') {
            outputEntry.code = inputValue[this.cle]
          } else {
            outputEntry.code = inputKey
          }

          if (this.valeur!=='') {
            outputEntry.libelle = inputValue[this.valeur]
          } else {
            outputEntry.libelle = inputValue
          }

          outputOptions.push(outputEntry)
        }

        return outputOptions
      }
    }
  },
  watch: {
    selection: function (val, oldVal) {
      if (Object.keys(val).length === 0) {
        //empeche de vider totalement le champ
        this.selection.push(oldVal[0])
      } else {
        let codes = []
        for (let selectedItem of val) {
          codes.push(selectedItem.code)
        }
        this.stringifySelection = codes.join(',')
      }
    }
  },
  created: function() {
    for (let selectedValue of this.selected) {
      for (let builtOption of this.builtOptions) {
        if (selectedValue === builtOption.code) {
          this.selection.push(builtOption)
          break
        }
      }
    }
  }
}
</script>
